module.exports = __webpack_public_path__ + "img/mark_body_female_image.c837fa86.svg";